import React, {Component} from "react";

class ConnectedSocket extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visibleErrorInformation: false
        };

        this.isChangeVisibleErrorInformation = this.isChangeVisibleErrorInformation.bind(this);
    }

    componentDidMount() {
        this.onSetVisibleErrorInformation()
    }

    onSetVisibleErrorInformation = () => {
        let timerId = setInterval(function () {
        }, 1000);

        let st = this.isChangeVisibleErrorInformation;

        setTimeout(function () {
            st(true);

            clearInterval(timerId);
        }, 15000);
    }

    isChangeVisibleErrorInformation(mark) {
        this.setState({visibleErrorInformation: mark})
    };

    isRefresh = () => {
        this.isChangeVisibleErrorInformation(false);
        this.onSetVisibleErrorInformation();

        if (this.props.isConnected === false) {
            this.props.createSession().then(r => {
                let {history, session} = r;
                this.props.onSetHistory(history)
                this.props.socketInit(session)
                this.props.updateLanguage(session)
                this.props.pushSessionToParentComponent(session)
            })
        }
        this.props.handlerUpdateCounterHistoryMessage()
    }

    render() {
        let chatLanguage = document.getElementById('chatLanguage');
        let lang = chatLanguage.getAttribute('data-language');

        return (
            <div className="sm-disconnect">
                {this.state.visibleErrorInformation ? <React.Fragment>
                    <b className="error-text">
                        {lang !== '' && lang.toLowerCase() === 'en' || lang.toLowerCase() === 'eng' && window.CONNECTED_REFRESH_TEXT_EN ? window.CONNECTED_REFRESH_TEXT_EN : null}
                        {lang !== '' && lang.toLowerCase() === 'ru' || lang.toLowerCase() === 'rus' && window.CONNECTED_REFRESH_TEXT_RU ? window.CONNECTED_REFRESH_TEXT_RU : null}
                        {lang !== '' && lang.toLowerCase() === 'ua' || lang.toLowerCase() === 'uk' || lang.toLowerCase() === 'ukr' && window.CONNECTED_REFRESH_TEXT_UA ? window.CONNECTED_REFRESH_TEXT_UA : null}
                        {lang !== '' && lang.toLowerCase() === 'uz' || lang.toLowerCase() === 'uzb' && window.CONNECTED_REFRESH_TEXT_UZB ? window.CONNECTED_REFRESH_TEXT_UZB : null}
                    </b>
                    <button
                        style={{backgroundColor: window.STYLE_HEADER_BACKGROUND_COLOR || window.DEFAULT_BUTTON_BACKGROUND_COLOR || '#005ba8'}}
                        onClick={this.isRefresh}
                    >
                        {lang !== '' && lang.toLowerCase() === 'en' || lang.toLowerCase() === 'eng' && window.CONNECTED_BTN_REFRESH_EN ? window.CONNECTED_BTN_REFRESH_EN : null}
                        {lang !== '' && lang.toLowerCase() === 'ru' || lang.toLowerCase() === 'rus' && window.CONNECTED_BTN_REFRESH_RU ? window.CONNECTED_BTN_REFRESH_RU : null}
                        {lang !== '' && lang.toLowerCase() === 'ua' || lang.toLowerCase() === 'uk' || lang.toLowerCase() === 'ukr' && window.CONNECTED_BTN_REFRESH_UA ? window.CONNECTED_BTN_REFRESH_UA : null}
                        {lang !== '' && lang.toLowerCase() === 'uz' || lang.toLowerCase() === 'uzb' && window.CONNECTED_BTN_REFRESH_UZB ? window.CONNECTED_BTN_REFRESH_UZB : null}
                    </button>
                </React.Fragment> : <span/>}
            </div>
        )
    }
}

export default ConnectedSocket;


// WEBPACK FOOTER //
// ./src/components/connectedSocket/index.js